import { Box, Flex, Stack, Title } from "@mantine/core";
import { CreateCampaign } from "../../features/create-campaign";
import { CampaignsFilters, CampaignsList } from "../../entities/campaigns/ui";

export const HomePage = () => {
  return (
    <Box p="md" pt="lg">
      <Flex justify="space-between" align="center">
        <Title order={1}>Campaigns</Title>

        <CreateCampaign />
      </Flex>

      <Stack mt="lg">
        <CampaignsFilters />

        <CampaignsList />
      </Stack>
    </Box>
  );
};
